var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../../utils';
import { renderIcon } from '../../utils/icon-utils';
import * as styles from './round-icon.styles';
import { ImageFallbackType, ImageWithFallback, } from '../image-with-fallback/image-with-fallback';
export var RoundIcon = function (_a) {
    var icon = _a.icon, iconSize = _a.iconSize, size = _a.size, imageUrl = _a.imageUrl, SvgIconComponent = _a.svgIcon, hexBackgroundColor = _a.hexBackgroundColor, backgroundColor = _a.backgroundColor, iconColor = _a.iconColor, className = _a.className, iconClassName = _a.iconClassName;
    var iconClasses = classNames(iconClassName, styles.roundIcon(iconSize));
    var content = null;
    if (SvgIconComponent) {
        content = (_jsx(SvgIconComponent, { className: classNames("text-".concat(iconColor), ' h-6 w-6 flex-shrink-0 ') }));
    }
    else if (imageUrl) {
        content = (_jsx(ImageWithFallback, { fallbackType: ImageFallbackType.TRANSPARENT_WHITE, className: iconClasses, src: imageUrl }));
    }
    else if (icon) {
        content = renderIcon(icon, iconClasses);
    }
    return (_jsx("div", __assign({ className: classNames(styles.roundIconContainer(size), className, "bg-".concat(backgroundColor), "text-".concat(iconColor)), style: hexBackgroundColor ? { backgroundColor: hexBackgroundColor } : {} }, { children: content })));
};
//# sourceMappingURL=round-icon.js.map